export const getNotificationInputs = (firstPendingActivity) => [
  {
    code: 'activitySelection',
    hint: 'Select Action',
    required: true,
    returnCode: true,
    type: 'sifg',
    sifg_options: {
      selection: {
        type: 'code_name_spinner',
        code_name_spinner_options: [
          {
            code: 'create',
            name: `Create ${
              firstPendingActivity?.name || firstPendingActivity?.id
            } Activity`,
          },
          { code: 'update', name: 'Complete Pending Activities' },
        ],
      },
      inputs: {
        create: [],
        update: [
          {
            code: 'activity_list',
            hint: 'Select Activity',
            type: 'entity_selection',
            required: true,
            workflowType: 'activity',
            filters: {
              stateId: '[{"code":"SCHEDULED","name":"Scheduled"}]',
              workflowId: firstPendingActivity?.workflowId,
            },
          },
        ],
      },
    },
  },
];
